export default {
  apiEndpoint: "https://cap-v2.stg.finervision.com",
  localStorage: {
    language: "e-learning-language",
    userAnswer: "e-learning-userAnswer",
    languageSelected: "e-learning-languageSelected",
  },
};
